import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import Icon from '../Icon';
import React from 'react';
import AbstractButton from '../AbstractButton';
import Box from '../Box';

/** A chip is an entry in a combobox, but can be used anywhere */
var Tag = function Tag(_ref) {
  var children = _ref.children,
      onRemove = _ref.onRemove,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "onRemove"]);

  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "tag",
    bg: "blue-400",
    borderRadius: "pill",
    cursor: "default",
    px: 2,
    fontSize: "small",
    fontWeight: "medium",
    zIndex: 1
  }, rest), children, /*#__PURE__*/React.createElement(AbstractButton, {
    onClick: onRemove,
    ml: 2,
    "aria-label": "Remove"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "x-small",
    type: "close"
  })));
};

export default Tag;